import { render, staticRenderFns } from "./StaffHolidayDialog.vue?vue&type=template&id=d2e4ddce&scoped=true"
import script from "./StaffHolidayDialog.vue?vue&type=script&lang=js"
export * from "./StaffHolidayDialog.vue?vue&type=script&lang=js"
import style0 from "./StaffHolidayDialog.vue?vue&type=style&index=0&id=d2e4ddce&prod&scoped=true&lang=css"
import style1 from "./StaffHolidayDialog.vue?vue&type=style&index=1&id=d2e4ddce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e4ddce",
  null
  
)

export default component.exports